var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import Lenis from 'lenis';

// Initialize Lenis
const lenis = new Lenis({
	lerp: 0.05, 
	wheelMultiplier: 1,
});

let header = $('header');
let lastScrollTop = 0;
const delta = 0.5;
var navbarHeight = $('.headerContainer').outerHeight();

var heroType1 = $('[data-section="heroType1"]');
var ctaType1 = $('[data-section="ctaType1"]');
var imagesType1 = $('[data-section="imagesType1"]');
var footer = $('footer');


lenis.on('scroll', (e) => {

	ticker();

    const st = e.scroll;


    // Ensure scroll has surpassed delta value before proceeding
    if (Math.abs(lastScrollTop - st) > delta) {

		// Check scroll direction and update header classes
		if (st > lastScrollTop && st > navbarHeight) {
			// Scrolled down
			if (header.hasClass('nav-down')) {
				header.removeClass('nav-down').addClass('nav-up');
				if ($('body.offset').length) {
					header.closest('section').attr('data-bg','secondary-one');
				}
			}
		} else {
			// Scrolled up
			if (st > navbarHeight && (st + $(window).height() < $(document).height())) {
				header.removeClass('nav-up').addClass('nav-down');
				header.closest('section').attr('data-bg','secondary-four');
			}

			if (st < 10) {
				header.removeClass('nav-up nav-down');
				if ($('body.offset').length) {
					header.closest('section').attr('data-bg','secondary-one');
				}
			}
		}
	}

    // Update last scroll position
    lastScrollTop = st;

	// animations
	if ($(window).width() >= 1024) {
		heroType1.each(function(index) {
			const scrollSpeed = 0.1;
			const offsetY = e.scroll * scrollSpeed * 1.5;
			$(this).find('.image-container').css('transform', 'translateY(' + offsetY + 'px)');
		});
		ctaType1.each(function(index) {
			const scrollSpeed = 0.1;
			const sectionOffset = $(this).offset().top; // Get the section's offset from the top of the page
			const scrollY = e.scroll; // Current scroll position
			const offsetY = (scrollY - sectionOffset) * scrollSpeed * 1.5; // Calculate the offset with section start point
			if (scrollY > sectionOffset - $(window).height() && scrollY < sectionOffset + $(this).outerHeight()) {
				$(this).find('.image-container').css('transform', 'translateY(' + offsetY + 'px)');
			}
		});
		imagesType1.each(function(index) {
			const scrollSpeed = 0.1;
			const sectionOffset = $(this).offset().top; // Get the section's offset from the top of the page
			const scrollY = e.scroll; // Current scroll position
			const offsetY = (scrollY - sectionOffset) * scrollSpeed * 1.5; // Calculate the offset with section start point
			if (scrollY > sectionOffset - $(window).height() && scrollY < sectionOffset + $(this).outerHeight()) {
				$(this).find('.image-container').css('transform', 'translateY(' + offsetY + 'px)');
			}
		});
		footer.each(function(index) {
			const scrollSpeed = 0.1;
			const sectionOffset = $(this).offset().top; // Get the section's offset from the top of the page
			const scrollY = e.scroll; // Current scroll position
			var offsetY = (scrollY - sectionOffset) * scrollSpeed * (-1.5); // Calculate the offset with section start point
			if (offsetY < 0) {
				offsetY = 0;
			}
			if (scrollY > sectionOffset - $(window).height() && scrollY < sectionOffset + $(this).outerHeight()) {
				$(this).find('.image-container').css('transform', 'translateY(' + offsetY + 'px)');
			}
		});
	}

});

// Use requestAnimationFrame to continuously update the scroll
function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}


import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});




// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	requestAnimationFrame(raf);

	ticker();

	if ($('[data-section="cardsType2"]').length) {
		$('[data-section="cardsType2"]').last().attr('data-unstuck','true');
	}

	if ($('[data-section="heroType1"][data-simple="false"]').length) {
		var heroEl = $('[data-section="heroType1"][data-simple="false"]');
		var nextSectionId = heroEl.next().attr('data-ni-block-id');
		heroEl.find('.link-icon').attr('href', '#section-' + nextSectionId);
	}

	var tourRequest = getUrlParameter('tourRequest') ?? false;
	var tourRequestField = $('.freeform-form [data-field-container="facilityTour"] .freeform-label');
	if (tourRequest && tourRequestField.length) {
		tourRequestField.trigger('click');
	}

	var cardsType2Section = $('[data-section="cardsType2"][data-bg="secondary-four"] + [data-section="cardsType2"][data-bg="secondary-four"]');
	if (cardsType2Section.length) {
		cardsType2Section.attr('data-bg','primary-two');
	}
});

/////////////////////




// SCROLL

$(window).on('scroll', function(e) {

});

////////////////////




// RESIZE

$(window).on('resize', function() {

});

////////////////////




// FORMS

$(function () {
	var forms = $('[data-freeform]');
	if (forms.length) {
		forms.each(function() {
			var formEl = $(this);
			dynamicCSRF(formEl);
			var btn = formEl.find('button.freeform-button-submit');
			var btnText = btn.text();
			if (btnText) {
				var newText = '<svg xmlns="http://www.w3.org/2000/svg" width="17.829" height="12.676" viewBox="0 0 17.829 12.676"><g transform="translate(0.5)"><path d="M7.635-.564l.083,8.281L-.564,7.634" transform="translate(5.701 6.46) rotate(-45)" fill="none" stroke="currentColor" stroke-width="1"></path><path d="M.151.334V6.981H16.61" transform="translate(-0.151 -0.334)" fill="none" stroke="currentColor" stroke-width="1"></path></g></svg><span>' + btnText + '</span>';
				btn.html(newText);
			}

			var successMessage = formEl.attr('data-success-message');
			var containerEl = formEl.parent();
			formEl.on('freeform-ajax-success', function (event) {
				// console.log(event.originalEvent)
				const form = event.originalEvent.form; // Use event.detail to access the form and response data
				const response = event.originalEvent.response;
				containerEl.addClass('success');
				containerEl.append('<div class="success-message"><div class="h6">' + successMessage + '</div></div>');
				// alert(`Successfully submitted Submission #${response.submissionId}`);
			});
		})
	}
    $('textarea').on('input', function () {
        $(this).css('height', 'auto'); // Reset height to calculate new scroll height
        $(this).css('height', this.scrollHeight + 'px'); // Set height to match the content
    });
});
async function dynamicCSRF(el) {
    // console.log('dynamicCSRF...');
	var form = el.attr('id');
    try {
        const response = await $.ajax({
            type: 'get',
            url: '/dynamic/csrf?form=' + form,
			dataType: 'json',
        });
		// console.log(response.csrf);
        if (response.csrf) {
			el.find('input[name=formHash]').val(response.hash);
			var csrf = response.csrf;
			el.find('input[name=' + csrf.name + ']').val(csrf.value);
        }
    } catch (error) {
        console.log('dynamicCSRF() error');
        console.log(error);
    }
}

///////////////////////////////////////




// sliderType1

$(document).ready(function() {
    let triggers = $('[data-section="sliderType1"] [data-trigger]');
    let interval;

    function startInterval() {
        interval = setInterval(function() {
            // Find the current "revealed" trigger and start from the next one
            let currentIndex = triggers.index($('[data-section="sliderType1"] [data-trigger][data-revealed="true"]'));
            let nextIndex = (currentIndex + 1) % triggers.length;

            $(triggers[nextIndex]).trigger('click'); // Trigger click on the next block
        }, 7000);
    }

    function resetInterval() {
		if ($(window).width() >= 1280) {
			clearInterval(interval);
			startInterval();
		}
    }

    if ($(window).width() >= 1280) {
    	startInterval();
	}

	$(document).on('click', '[data-section="sliderType1"] [data-trigger]', function(e) {
		var section = $(this).closest('section');
		var othersTrigger = section.find('[data-trigger]');
		var othersContent = section.find('[data-trigger-content]');
		var othersImage = section.find('[data-trigger-image]');
		var revealed = $(this).attr('data-revealed');
		var uid = $(this).attr('data-trigger');
		var content = section.find('[data-trigger-content="' + uid + '"]');
		var image = section.find('[data-trigger-image="' + uid + '"]');
		if (revealed == 'false') {
			othersTrigger.attr('data-revealed','false');
			othersContent.slideUp(300);
			othersImage.attr('data-revealed','false');
			content.slideDown(300);
			$(this).attr('data-revealed','true');
			image.attr('data-revealed','true');
		}
	});

    // Pause on hover
    $(document).on('mouseenter', '[data-section="sliderType1"] [data-trigger]', function() {
        clearInterval(interval); // Pause
    }).on('mouseleave', '[data-section="sliderType1"] [data-trigger]', function() {
        resetInterval(); // Resume when hover ends
    });
});

///////////////////////////////////////




// descriptionRichNumbers

var tickerTriggered = false;

function ticker() {
	if (!tickerTriggered) {
		var numberDiv = $('[data-section="textType1"] [data-block="descriptionRichNumbers"] [data-target]');
		if (!numberDiv.length) {
			return false;
		}
		var inView = isElementInViewport(numberDiv[0]); // Check if the element is in view
		if (inView) {
			numberDiv.each(function () {
				var numberEl = $(this).find('.number');
				var currentValue = numberEl.text().replace(/,/g, ''); // Remove commas before parsing
				var targetValue = parseFloat(currentValue);
				$(this).prop('Counter', 0).animate({
					Counter: targetValue
				}, {
					duration: 1500,
					easing: 'swing',
					step: function (now) {
						numberEl.text(addCommas(Math.ceil(now))); // Add commas back after rounding
					}
				});
			});
			tickerTriggered = true; // Set the flag to true after triggering the animation
		}
	}
}

// Function to check if an element is in the viewport
function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

// Function to add commas to numbers
function addCommas(nStr) {
	nStr += '';
	var x = nStr.split('.');
	var x1 = x[0];
	var x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}

///////////////////////////////////////




// POPUPS - TEAM

$(document).on('click', '[data-popup-trigger]', function(e) {
	header.removeClass('nav-up nav-down');
	setTimeout(() => {
		header.removeClass('nav-up nav-down');
	}, 500);
	$('body').attr('data-menu-revealed','true');
	if ($('aside.main-menu').attr('data-menu-revealed') == 'true') {
		$('[data-menu-trigger]').trigger('click')
	}
	var uid = $(this).attr('data-popup-trigger');
	$(this).attr('data-popup-revealed','true');
	$('aside[data-popup="' + uid + '"]').attr('data-popup-revealed','true');
	$('aside[data-popup="' + uid + '"]').attr('data-container-revealed','true');
	lenis.stop();
});

$(document).on('click', '[data-trigger-popup-close]', function(e) {
	header.removeClass('nav-up nav-down');
	$('body').attr('data-menu-revealed','false');
	$('aside[data-popup]').attr('data-popup-revealed','false');
	$('[data-popup-trigger]').attr('data-popup-revealed','false');
	setTimeout(() => {
		$('aside[data-popup]').attr('data-container-revealed','false');
	}, 1000);
	lenis.start();
});

////////////////////




// FILTER - NEWS

let currentPage_N = 1;
let loading_N = false;
let currentCategory_N = 'all';
let cardsEl_N = $('section[data-section="filterNews"] .column-cards');
let loadMoreEl_N = $('section[data-section="filterNews"] [data-load-more]');

// Handle category filter click
$(document).on('click', 'section[data-section="filterNews"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();
    currentCategory_N = $(this).attr('data-filter-value');
    currentPage_N = 1;
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');
    cardsEl_N.empty();
	// console.log('currentPage_N ' + currentPage_N)
	// console.log('currentCategory_N ' + currentCategory_N)
    loadMoreNews(currentPage_N, currentCategory_N);

	//update url
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('category', currentCategory_N);
	window.history.replaceState({}, document.title, url.toString());
});


$(document).on('click', 'section[data-section="filterNews"] [data-load-more]', function (e) {
    e.preventDefault();

    if (loading_N) return;
    loading_N = true;

    currentPage_N++;
    loadMoreNews(currentPage_N, currentCategory_N);
});

async function loadMoreNews(page, category = 'all') {
    try {
        const response = await $.ajax({
            type: 'get',
            url: `/news.json?page=${page}&category=${category}`,
        });

        // console.log('Loaded page ' + page, response);

        let events = response.data;
        let limit = 8;
        if (events.length > 0) {
            events.forEach(function (event) {
                cardsEl_N.append(event.html);
				limit = event.limit;
            });

            loading_N = false; // Allow loading more pages
        }
		// console.log('limit ' + limit)
		// console.log('events.length ' + events.length)
		if (events.length < limit || events.length == 0) {
            loadMoreEl_N.attr('data-load-more','false');
		} else {
            loadMoreEl_N.attr('data-load-more','true');
		}

    } catch (error) {
        console.log('Error loading more events:', error);
    }
}

////////////////////




// LIST TYPE 2

$(document).on('click', '[data-section="listType2"] .list-heading', function(e) {
	var revealed = $(this).attr('data-revealed');
	if (revealed == 'false') {
		$(this).find('.link').text('Less');
		$(this).attr('data-revealed','true');
		$(this).parent().find('.list-content').slideDown(300);
	} else {
		$(this).find('.link').text('More');
		$(this).attr('data-revealed','false');
		$(this).parent().find('.list-content').slideUp(300);
	}
});

////////////////////




// MENU

$(document).on('click', '[data-menu-trigger]', function(e) {
	var revealed = $(this).attr('data-menu-revealed');
	if (revealed == 'false') {
		$(this).text('Close');
		$(this).attr('data-menu-revealed','true');
		$('body').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-menu-revealed','true');
		$('aside.main-menu').attr('data-container-revealed','true');
		lenis.stop();
	} else {
		$(this).text('Menu');
		$(this).attr('data-menu-revealed','false');
		$('body').attr('data-menu-revealed','false');
		$('aside.main-menu').attr('data-menu-revealed','false');
		setTimeout(() => {
			$('aside.main-menu').attr('data-container-revealed','false');
		}, 1000);
		lenis.start();
	}
});

////////////////////




// HELPERS

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  

///////////////////////////////////////




// LINK FILTERS
const newsFilterSection = $('section[data-section="filterNews"]');

$(function() {
	if (newsFilterSection.length) {
		var filter = getUrlParameter('category');
		var filterButton = newsFilterSection.find('[data-filter-value="' + filter + '"]');
		if (filterButton.length) {
			filterButton.trigger('click')
			
		}
	}
});


////////////////

const $sectionSelector = $('[data-section="cardsType3"]');
if ($sectionSelector.length) {
	$sectionSelector.each(function() {
		let $instance = $(this);

		if ($(window).width() > 540)
			setTimeout(function() {
				wbMatchParagraphHeight($instance);
			}, 100);
		else
			$instance.find('.block-content').css('min-height', 'auto');

		$(window).on('resize', function() {
			if ($(window).width() > 540)
				wbMatchParagraphHeight($instance);
			else
				$instance.find('.block-content').css('min-height', 'auto');
			
		});
	});

}

function wbMatchParagraphHeight ($el) {
	let $pBlocks = $el.find('.block-content');
	let parentOffset = $el.find('.block-cta').first().outerHeight() * 0.5; //adjust min-height based on offset
	let maxHeight = 0;
	$($pBlocks).each(function() {
		maxHeight = Math.max(maxHeight, $(this).outerHeight());
	});
	let addonOfffset = parentOffset > maxHeight ? parentOffset - maxHeight : 0;
	$pBlocks.css('min-height', (maxHeight + addonOfffset) + 'px');
	maxHeight = 0;
}

// 

/// CONTACT US cardsType4 - SHOW MORE
$('[data-section="cardsType4"]').each(function() {
	const $parent = $(this);
	const $btn = $(this).find('.showMore');

	$btn.click(function() {
		$parent.addClass('mob-active');
	})
});


function updateDragDropText() {
	if($('.freeform-file-dnd__placeholder').length && $(window).width() < 641) {
		$('.freeform-file-dnd__placeholder').text('Click to upload files');
	}
}

updateDragDropText();

$(window).resize(function() {
	// console.log('resizing');
	updateDragDropText();
});